import React from "react";
import styled, { css } from "styled-components";

type IconProps = {
  name: string;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>, id?: string) => void;
  hideMargin?: boolean;
  width?: number;
  height?: number;
  showCursor?: boolean;
};

const Icon = (props: IconProps) => {
  const {
    name,
    className,
    onClick,
    hideMargin = false,
    width,
    height,
    showCursor,
  } = props;
  return (
    <IconContainer
      className={className}
      onClick={onClick}
      hideMargin={hideMargin}
    >
      <IconImage
        alt={`icon_${name}`}
        src={`/icons/${name}.svg`}
        width={width}
        height={height}
        showCursor={Boolean(showCursor)}
      />
    </IconContainer>
  );
};

export default Icon;

type IconContainerProps = {
  hideMargin: boolean;
};
const IconContainer = styled.div<IconContainerProps>`
  margin: ${(props) => (props.hideMargin ? "0" : "0 0.625rem")};
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
`;

const IconImage = styled.img<{ showCursor: boolean }>`
  ${(props) => {
    if (props.showCursor) {
      return css`
        cursor: pointer;
      `;
    }
  }}
`;
